// client/src/components/learning/MidLessonQuiz.tsx
import React from "react";
import { LessonSegment } from "../../types/learning";

interface MidLessonQuizProps {
  moduleData: LessonSegment;
  onComplete: (moduleId: string, data?: any) => void;
}

const MidLessonQuiz: React.FC<MidLessonQuizProps> = ({ moduleData, onComplete }) => {
  return (
    <div>
      <h2>{moduleData.title} - Quiz</h2>
      <p>{moduleData.content}</p>
      <button onClick={() => onComplete(moduleData.id, { quizScore: 100 })}>
        Complete Quiz
      </button>
    </div>
  );
};

export default MidLessonQuiz;
